import { render, staticRenderFns } from "./flowInstanceHis.vue?vue&type=template&id=c19f3c94"
import script from "./flowInstanceHis.vue?vue&type=script&lang=js"
export * from "./flowInstanceHis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports